/* FrameSoothe product page: gallery, bundle + free gifts + add-on, add to cart, delivery dates, sticky bar */
(function () {
  function initGallery(root) {
    var track = root.querySelector('[data-gal-track]');
    if (!track) return;
    var slides = track.children;
    var thumbs = root.querySelectorAll('[data-gal-thumb]');
    var dots = root.querySelectorAll('[data-gal-dots] span');
    function go(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); }
    function current() { return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); }
    function mark() {
      var i = current();
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    root.querySelectorAll('[data-gal-nav]').forEach(function (b) {
      b.addEventListener('click', function () { go(current() + (b.getAttribute('data-gal-nav') === 'next' ? 1 : -1)); });
    });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
    mark();
  }

  function initDelivery(root) {
    root.querySelectorAll('[data-ds-eta]').forEach(function (el) {
      var parts = el.getAttribute('data-ds-eta').split('-');
      var a = parseInt(parts[0], 10), b = parseInt(parts[1] || parts[0], 10);
      function addBiz(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
      var opts = { month: 'short', day: 'numeric' };
      var now = new Date();
      try { el.textContent = addBiz(now, a).toLocaleDateString(document.documentElement.lang || 'en', opts) + ' – ' + addBiz(now, b).toLocaleDateString(document.documentElement.lang || 'en', opts); } catch (e) {}
    });
  }

  function initBundle(root) {
    var form = root.querySelector('[data-ds-bundle]');
    if (!form) return;
    var err = root.querySelector('[data-ds-err]');
    var nowEl = root.querySelector('[data-ds-now]');
    var wasEl = root.querySelector('[data-ds-was]');
    var saveEl = root.querySelector('[data-ds-save]');
    var stickyPrice = document.querySelector('[data-ds-sticky-price]');

    function selected() { return form.querySelector('input[name="ds-tier"]:checked'); }
    function refresh() {
      var t = selected();
      if (!t) return;
      var now = parseInt(t.getAttribute('data-now'), 10);
      var was = parseInt(t.getAttribute('data-was'), 10);
      if (nowEl) nowEl.textContent = t.getAttribute('data-now-label');
      if (wasEl) { wasEl.textContent = was > now ? t.getAttribute('data-was-label') : ''; wasEl.hidden = !(was > now); }
      if (saveEl) {
        var pct = was > now ? Math.round((1 - now / was) * 100) : 0;
        saveEl.textContent = pct > 0 ? 'Save ' + pct + '%' : '';
        saveEl.hidden = pct <= 0;
      }
      if (stickyPrice) stickyPrice.textContent = t.getAttribute('data-now-label');
    }
    form.addEventListener('change', refresh);
    refresh();

    function items() {
      var t = selected();
      var list;
      try { list = JSON.parse(t.getAttribute('data-items')); } catch (e) { list = [{ id: Number(t.value), quantity: 1 }]; }
      var addon = root.querySelector('[data-fs-addon]');
      if (addon && addon.checked) {
        var id = Number(addon.value), hit = list.filter(function (i) { return i.id === id; })[0];
        if (hit) hit.quantity += 1; else list.push({ id: id, quantity: 1 });
      }
      return list;
    }

    async function add(goCheckout, btn) {
      if (err) err.hidden = true;
      var label = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = goCheckout ? 'Going to checkout…' : 'Adding…';
      try {
        var drawer = document.querySelector('cart-drawer');
        var body = { items: items() };
        if (drawer && !goCheckout) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
        var r = await fetch(((window.routes && routes.cart_add_url) || '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
        });
        var data = await r.json();
        if (!r.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
        if (goCheckout) { window.location.href = '/checkout'; return; }
        if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
          drawer.renderContents(data);
        } else {
          window.location.href = (window.routes && routes.cart_url) || '/cart';
          return;
        }
      } catch (e) {
        if (err) { err.textContent = e.message; err.hidden = false; }
      }
      btn.disabled = false;
      btn.innerHTML = label;
    }
    root.querySelectorAll('[data-ds-add-bundle]').forEach(function (b) {
      b.addEventListener('click', function () { add(b.getAttribute('data-ds-add-bundle') === 'checkout', b); });
    });

    var sticky = document.querySelector('[data-ds-sticky]');
    var buy = root.querySelector('[data-ds-buy]');
    if (sticky && buy) {
      var check = function () { sticky.classList.toggle('is-on', buy.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', function () { window.requestAnimationFrame(check); }, { passive: true });
      window.addEventListener('resize', check);
      check();
      var sb = sticky.querySelector('[data-ds-sticky-btn]');
      if (sb) sb.addEventListener('click', function () { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }
  }

  function init() {
    document.querySelectorAll('[data-fs-pdp]').forEach(function (root) {
      if (root.dataset.fsReady) return; root.dataset.fsReady = '1';
      initGallery(root); initDelivery(root); initBundle(root);
    });
    document.querySelectorAll('[data-ds-totop]').forEach(function (b) {
      if (b.dataset.dsReady) return; b.dataset.dsReady = '1';
      b.addEventListener('click', function () {
        var t = document.querySelector('[data-ds-bundle]') || document.body;
        t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
